module.exports = __webpack_public_path__ + "665ffb9094b69d9d38973664bbd62599.svg";